<template>
  <div>
    <div v-show="change && (change||{}).type === 'text'" class="custom-tip">修改前: {{ (change||{}).tip }}</div>
    <div v-show="change && (change||{}).type === 'image'" class="custom-tip">
      修改前: <el-image style="width: 32px; height: 32px" :src="(change||{}).src" :preview-src-list="(change||{}).preview_src_list"></el-image>
    </div>
    <div v-show="change && (change||{}).type === 'video'" class="custom-tip">
      修改前: <video :src="(change||{}).src" width="32px" height="32px" muted autoplay loop>您的浏览器不支持 video 标签</video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeTips',
  props: {
    change: {
      type: Object
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {}
}
</script>
<style scoped>
.custom-tip {
  color: orange;
  font-size: 11px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/idea/ChangeTips.vue